export const blockIconsMapsLocationAwayNew = (
	<span className='material-symbols-outlined'>location_away</span>
);
